import Mingu from '../assets/images/mingu.jpeg';
import Run from '../assets/images/run.jpeg';
import VB from '../assets/images/vb.jpeg';
import Beauty from '../assets/images/image.jpeg';
import Dumpies from '../assets/images/dumpies.jpeg';
import Sunset from '../assets/images/sunset.jpeg';
import Griffith from '../assets/images/griffith.jpeg';
import Brunchie from '../assets/images/brunchie.jpg';
import Mekabir from '../assets/images/mekabir.png';

export const about = {
  title: 'About me',
  statement:
    'my craft is building software that solves real problems — from full-stack web apps to automation and APIs, with a focus on clean code and thoughtful user experience.',
  quote:
    '"I saw the angel in the marble and carved until I set him free." — Michelangelo',
  paragraphs: [
    'I enjoy building projects that serve as a challenge, which roots from building Lego sets as a child. It was often the case that I would set the manual aside and build my own interpretations of the pieces after completing a set. I find myself approaching projects not even knowing what I plan its full scope to be, let alone what the technology stack will be.',
    'What began as a journey into the healthcare industry at the University of Toronto turned out to reveal a passion for software and its complexity. I knew I was always good at math, I just didn\'t know where to go with that. After lots of soul searching, I decided to pursue CS.',
    'I am currently building several projects that I believe will serve as technological assets to their users.',
    'When not coding, I find myself playing volleyball, running, at the gym, cooking, baking, taking amateur photographs, or watching F1. I have also been learning a few languages, and the one I feel I am most comfortable in out of the bunch is Dutch.',
  ],
  hobbies: ['volleyball', 'running', 'gym', 'cooking', 'baking', 'photography', 'F1', 'Dutch'],
  photos: [
    { src: Mekabir, alt: 'Portrait' },
    { src: Griffith, alt: 'Griffith' },
    { src: Mingu, alt: 'Lemon Meringue Pie' },
    { src: Brunchie, alt: 'Brunch in the mountains' },
    { src: VB, alt: 'Volleyball' },
    { src: Beauty, alt: 'Harwood Dock Sunset' },
    { src: Run, alt: 'Running' },
    { src: Dumpies, alt: 'Dumplings' },
    { src: Sunset, alt: 'Sunset' },
  ],
};
